<template lang="pug">
  b-modal#knockOffFreeCreditMember(
    ref="knockOffFreeCreditMember"
    :title='$t("ui.combine.knock_off_free_credit_member")'
    centered
    no-fade
    no-close-on-backdrop
    :busy="loading"
    @ok="done"
    @show="reset"
    @shown="shown")
    template(v-if="item")
      .clusterize-scroll.table-responsive
        table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
          thead.thead-light
            tr
              th(colspan="2")
                span  {{ $t("ui.promotion") }}
          tbody
            tr
              td
                span {{ $t("ui.account_id") }}
              td
                span {{ item.account_id }}
            tr
              td
                span {{ $t("ui.criteria") }}
              td
                span {{ item.criteria }}
            tr
              td
                span {{ $t("ui.base_amount") }}
              td
                span {{ $n(item.base_amount, 'currency') }}
            tr
              td
                span {{ $t("ui.rollover") }}
              td
                span {{ item.rollover }}
            tr
              td
                span {{ $t("ui.target_amount") }}
              td
                span {{ $n(item.target_amount, 'currency') }}
            tr
              td
                span {{ $t("ui.claim_date") }}
              td
                span {{ $moment(item.claim_date).format("YYYY-MM-DD, HH:mm:ss") }}
            tr(v-if="item.criteria.toUpperCase() == 'WIN'")
              td
                span {{ $t("ui.accumulate_win") }}
              td
                span {{ $n(item.accumulate_win, 'currency') }}
            tr(v-if="item.criteria.toUpperCase() == 'TURNOVER'")
              td
                span {{ $t("ui.accumulate_turnover") }}
              td
                span {{ $n(item.accumulate_turnover, 'currency') }}
      b-form-group(:label="$t('ui.remark')" v-if="item.status != -1").mb-0
        DebounceInput(
          size="sm"
          type="text"
          :dirty="$v.remark.$dirty"
          :error="$v.remark.$error"
          v-model.trim.lazy="$v.remark.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.remark" :name="$t('ui.remark')")
      div(slot="modal-footer")
        SubmitButton.float-right(icon="fa fa-hand-paper" :text="$t('ui.knock_off')" @click="knockOff()" size="sm" variant="danger").mr-1
        SubmitButton.float-right(icon="far fa-times-circle" :text="$t('ui.close')" @click="closeModal()" size="sm" variant="primary").mr-1
</template>

<script>
import { required } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import DebounceInput from "@/library/DebounceInput";
import ValidateResult from "@/library/ValidateResult";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    ValidateResult
  },
  props: {
    item:{
      type: Object
    }
  },
  data() {
    return {
      loading: false,
      remark: '',
      feedback: {
        success: true,
        status: ""
      },
    };
  },
  computed: {
    operatorID() {
      return this.$store.getters.selectedOperatorID
    }
  },
  mounted: function() {
  },
  validations: {
    remark: {
      required
    },
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.remark = '';
    },
    knockOff: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.confirmKnockOff();
      }
    },
    confirmKnockOff: function() {
      let url = config.promotionMemberKnockOffFreeUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        member_id: this.item.account_id,
        remark: this.remark,
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$emit("clicked");
                this.$refs.knockOffFreeCreditMember.hide();
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {

          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    closeModal: function() {
      this.$v.$reset();
      this.$refs.knockOffFreeCreditMember.hide();
    },
  }
};
</script>
